export default "__VITE_ASSET__CqnPC9FS__"